import { PublicClientApplication } from "@azure/msal-browser";

const getMsalAuthority = () => {
  const openIdAuthority = process.env.REACT_APP_OPENID_AUTHORITY;
  if (!openIdAuthority) {
    return "https://login.microsoftonline.com/common";
  }
  return openIdAuthority.replace(/\/oauth2\/.*$/, "");
};

export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_OPENID_CLIENT_ID || "msal-client-id-not-configured",
    authority: getMsalAuthority(),
    redirectUri: process.env.REACT_APP_OPENID_REDIRECT_URI || window.location.origin,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: ["User.Read"],
  nonce: "1",
};

export const msalInstance = new PublicClientApplication(msalConfig);
